import { Paragraph } from '@rover/kibble/core';

import { Props } from './HTMLText.common';
import { sanitizeHTML } from './sanitizeHTML';

const HTMLText = ({ text, ...other }: Props): JSX.Element => {
  return (
    /* @ts-expect-error eslint-disable-next-line react/no-danger */
    <Paragraph dangerouslySetInnerHTML={{ __html: sanitizeHTML(text) }} {...other} />
  );
};

export default HTMLText;
